var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Paper',{attrs:{"header":_vm.header,"tall":""}},[_c('div',{staticClass:"rounded-bottom",staticStyle:{"overflow":"hidden"}},[_c('LinkCarouselItem',{attrs:{"title":_vm.title,"img":_vm.img,"link":_vm.link,"inSameWindow":_vm.inSameWindow}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }